<template>
  <div>
    <div class="container-00">
      <div class="osc-block-00 osc-border-00 card-00">
        <div class="card-title-00">
          {{ parameter_group_title }} &nbsp;
          <v-btn x-small icon v-on:click="dump_osc_param()"><v-icon>mdi-text-box-outline</v-icon></v-btn>
        </div>
        <div class="knob-block-00">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">OCTV</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="62" max="66" :value="osc_param.octave" v-on:change="onUpdateParam('octave', $event.target.value)" conv="const val=x-64; (val>0) ? '+' + val : val" tooltip="Octave Select<br/>%s"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">SEMITONE</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="52" max="76" :value="osc_param.semitone" v-on:change="onUpdateParam('semitone', $event.target.value)" conv="const val=x-64; val" tooltip="Seminote Tuning<br/>%d"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">FINE</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="14" max="114" :value="osc_param.fine" v-on:change="onUpdateParam('fine', $event.target.value)" conv="const val=x-64; (val>0) ? '+' + val : val" tooltip="Fine Tuning<br/>%s cents"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">BEAT</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.beat" v-on:change="onUpdateParam('beat', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Beat Tuning<br/>%s %"></webaudio-knob></div>
            </div>
          </div>
        </div>
        <!-- --------------------- -->
        <div class="slider-block-00">
          <div class="slider-00-child-00">
            <div class="slider-label-00 justify-align-center mb-1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon :size="wava_icon_size" v-bind="attrs" v-on="on">mdi-sawtooth-wave</v-icon>
                </template>
                <span>Sawtooth</span>
              </v-tooltip>
            </div>
            <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="osc_param.sawtooth" v-on:change="onUpdateParam('sawtooth', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Sawtooth Level<br/>%d %"></webaudio-slider></div>
          </div>
          <div class="slider-00-child-00">
            <div class="slider-label-00 justify-align-center mb-1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon :size="wava_icon_size" v-bind="attrs" v-on="on">mdi-triangle-wave</v-icon>
                </template>
                <span>Triangle</span>
              </v-tooltip>
            </div>
            <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="osc_param.triangle" v-on:change="onUpdateParam('triangle', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Triangle Level<br/>%d %"></webaudio-slider></div>
          </div>
          <div class="slider-00-child-00">
            <div class="slider-label-00 justify-align-center mb-1">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon :size="wava_icon_size" v-bind="attrs" v-on="on">mdi-square-wave</v-icon>
                </template>
                <span>Square</span>
              </v-tooltip>
            </div>
            <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="osc_param.square" v-on:change="onUpdateParam('square', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Pulse Level<br/>%d %"></webaudio-slider></div>
          </div>
        </div>
        <div class="slider-block-00-pulse">
          <div class="slider-00-child-00">
            <div class="slider-label-00">┐</div>
            <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/simplegray.png" diameter="32" min="0" max="127" :value="osc_param.pulseWidth" v-on:change="onUpdateParam('pulseWidth', $event.target.value)"  conv="Math.round(100 * x / 127)" tooltip="Pulse Width Amount<br/>%d %"></webaudio-knob></div>
            <div class="slider-label-00 justify-align-center">PULSE<br>WIDTH</div>
          </div>
        </div>
        <!-- --------------------- -->
        <div class="knob-block-00">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">PWM</div><div>FREQ</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.pwmFreq" v-on:change="onUpdateParam('pwmFreq', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="PWM Frequency<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">SWEEP</div><div>TIME</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.sweepTime" v-on:change="onUpdateParam('sweepTime', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Sweep Time<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DEPTH</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.pwmDepth" v-on:change="onUpdateParam('pwmDepth', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="PWM Depth<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DEPTH</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.sweepDepth" v-on:change="onUpdateParam('sweepDepth', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Sweep Depth<br/>%s %"></webaudio-knob></div>
            </div>
          </div>
        </div>

        <!-- --------------------- -->
        <div class="knob-block-00 breath-border-00">
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00">BREATH</div><div>ATTAIN</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-0" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.breathAttain" v-on:change="onUpdateParam('breathAttain', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Breath to Pitch Attain<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center"><div class="label-title-00"></div><div>THRESH</div></div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.breathThreshold" v-on:change="onUpdateParam('breathThreshold', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Breath to Amp Threshold<br/>%d %"></webaudio-knob></div>
            </div>
          </div>
          <div class="knob-00-parent">
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">DEPTH</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.breathDepth" v-on:change="onUpdateParam('breathDepth', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Breath to Pitch Depth<br/>%d %"></webaudio-knob></div>
            </div>
            <div class="knob-00-child-00">
              <div class="knob-label-00 justify-align-center">CURVE</div>
              <div class="knob-ctrl-00"><webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="32" min="0" max="127" :value="osc_param.breathCurve" v-on:change="onUpdateParam('breathCurve', $event.target.value)" conv="const val=Math.round(100 * x / 127)-50; (val>0) ? '+' + val : val" tooltip="Breath Curce<br/>%s %"></webaudio-knob></div>
            </div>
          </div>
        </div>

        <!-- --------------------- -->
        <div class="slider-block-00">
          <div class="slider-00-child-00" :style="{ visibility: xfade_visibility}">
            <div class="slider-label-00 justify-align-center">X-FADE</div>
            <div class="knob-ctrl-00">
              <webaudio-switch id="sw1" colors="#0f0;#fff;#fff" :value="osc_param.x_fade" v-on:change="onUpdateParam('x_fade', Boolean($event.target.value))" tooltip="Cross Fade"></webaudio-switch>
            </div>
          </div>
          <div class="slider-00-child-00">
            <div class="slider-label-00 justify-align-center">LEVEL</div>
            <div class="slider-ctrl-00"><webaudio-slider width="20" id="slider10" direction="vert" colors="#fff;#444;#fff" min="0" max="127" :value="osc_param.level" v-on:change="onUpdateParam('level', $event.target.value)" conv="Math.round(100 * x / 127)" tooltip="Volume Level<br/>%d %"></webaudio-slider></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'Oscillator',
   props: ['parameter_group_title', 'label', 'oscparam', 'xfade_button'],
   methods: {
     dump_osc_param: function() {
       const workingPatch_idx = this.$store.getters.getWorkingPatchIdx()
       const workingPatch = this.$store.getters.getOneEditPatch(workingPatch_idx)
       console.log(`[${this.label}:store]`, workingPatch.decoded[`${this.label}Decoded`])
       console.log(`[${this.label}:local]`, this.osc_param)
       console.log(`[${this.label}.osc2Xfade]`, workingPatch.decoded)
     },
     onUpdateParam: function(key, val) {
       if (key == 'x_fade') {
         val = (val==true) ? 1 : 0
         this.$store.commit('onEditOneEditPatch', {arr_idx: ['osc2Xfade'], value: Uint8Array.from([val])})
       } else {
         this.$store.commit('onEditOneEditPatch', {arr_idx: [`${this.label}Decoded`, key], value: val})
       }
       this.$set(this.$data.osc_param, key, val)

       // let PatchNumNameCard component to recognise params change
       this.$router.app.$children[0].updateParamIsSyncedApp()
     }
   },
   created: function() {
     console.log(`<CREATED> label=[${this.label}]`)
     Object.keys(this.oscparam).forEach( key => {
       this.$data.osc_param[key] = this.oscparam[key]
     })
   },
   computed: {
     xfade_visibility: {
       get: function() {
         return this.xfade_button ? 'unset' : 'hidden'
       },
       set: function() {
       }
     }
   },
   watch: {
     osc_param: {
       handler() {
       //console.log('[!!!!!!!!!!!!! osc_param changed]')
       },
       deep: true
     },
     label: function() {
       //console.log('[!!!!!!!!!!!!! label changed]')
     }
   },
   data: () => ({
     wava_icon_size: 16,
     //label: null,
     osc_param: {
       octave: 0,
       fine: 0,
       semitone: 0,
       beat: 0,
       sawtooth: 0,
       triangle: 0,
       square: 0,
       pulseWidth: 0,
       pwmFreq: 0,
       pwm_depth: 0,
       sweep_time: 0,
       sweep_depth: 0,
       breath_attain: 0,
       breath_depth: 0,
       breath_thresh: 0,
       breath_curve: 0,
       x_fade: false,
       level: 0
     }
   })
 }
</script>
